export const AUTH_TOKEN_KEY = "scan_auth_token";
export const AUTH_USER_KEY = "scan_auth_user";
export const AUTH_ROLE_KEY = "scan_auth_role";

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY) || "";
}

export function getAuthRole() {
  return localStorage.getItem(AUTH_ROLE_KEY) || "";
}

export function getAuthUser() {
  const raw = localStorage.getItem(AUTH_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAuthSession(data) {
  const token = data?.token || "";
  const user = data?.user || null;
  const role = user?.role || "";

  if (!token || !role) return;

  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  localStorage.setItem(AUTH_ROLE_KEY, role);

  localStorage.setItem("admin_logged_in", role === "admin" || role === "super_admin" ? "true" : "false");
  localStorage.setItem("user_logged_in", role === "user" || role === "admin" || role === "super_admin" ? "true" : "false");
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${AUTH_TOKEN_KEY}=${encodeURIComponent(token)}; Path=/; SameSite=Lax; Max-Age=2592000${secure}`;
}

export function clearAuthSession() {
  [
    AUTH_TOKEN_KEY,
    AUTH_USER_KEY,
    AUTH_ROLE_KEY,
    "admin_logged_in",
    "user_logged_in",
  ].forEach(key => localStorage.removeItem(key));
  document.cookie = `${AUTH_TOKEN_KEY}=; Path=/; SameSite=Lax; Max-Age=0`;
}

export function hasAuthRole(role) {
  const currentRole = getAuthRole();
  if (!getAuthToken()) return false;
  if (currentRole === role) return true;
  if (currentRole === "super_admin" && (role === "admin" || role === "user")) return true;
  if (currentRole === "admin" && role === "user") return true;
  return false;
}

export function hasAnyAuthRole(roles) {
  return Boolean(getAuthToken()) && roles.some(role => hasAuthRole(role));
}

export function isSuperAdmin() {
  return Boolean(getAuthToken()) && getAuthRole() === "super_admin";
}

export function getAuthPermissions() {
  const user = getAuthUser();
  return Array.isArray(user?.permissions) ? user.permissions : [];
}

export function hasPermission(permission) {
  if (isSuperAdmin()) return true;
  if (getAuthRole() === "user") {
    return (permission === "cancel_packets" || permission === "return_claims")
      && getAuthPermissions().includes(permission);
  }
  if (!hasAuthRole("admin")) return false;
  return getAuthPermissions().includes(permission);
}
